import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/miqGry1R8t4ne9Nm4mdeyy/Captura_de_pantalla_2026-05-19_140813.png',
  caption: 'Vela queso & charcutería — Tabla salada gourmet'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iL9PKmw9Qp2n8AsGrGSNNT/Captura_de_pantalla_2026-05-19_140756.png',
  caption: 'Vela camembert horneado con panecillos'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vZsCpVxDszqTKnZXRwaWro/Captura_de_pantalla_2026-05-19_140746.png',
  caption: 'Vela brie con arándanos y romero para untar'
}];
export function SavoryGallery() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % IMAGES.length);
    }, 4000);
    return () => clearInterval(id);
  }, []);
  return <div className="mt-8" data-id="element-298">
      <div className="text-center mb-4" data-id="element-299">
        <span className="inline-block text-brand-gold font-bold tracking-widest text-[10px] md:text-xs uppercase border border-brand-gold/30 px-3 py-1 rounded-full bg-brand-gold/10" data-id="element-300">
          🧀 Velas Saladas
        </span>
        <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-choco-deep mt-2" data-id="element-301">
          Lo que vas a poder ofrecer
        </h3>
      </div>

      <div className="relative aspect-[4/5] md:aspect-[16/10] rounded-2xl overflow-hidden shadow-xl border border-brand-choco/10 bg-brand-choco-deep max-w-2xl mx-auto" data-id="element-302">
        <AnimatePresence mode="wait" data-id="element-303">
          <motion.div key={index} initial={{
          opacity: 0,
          scale: 1.05
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.98
        }} transition={{
          duration: 0.8,
          ease: 'easeInOut'
        }} className="absolute inset-0" data-id="element-304">
            <img src={IMAGES[index].src} alt={IMAGES[index].caption} className="w-full h-full object-cover" data-id="element-305" />
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 bg-gradient-to-t from-black/75 via-black/30 to-transparent" data-id="element-306">
              <p className="text-white font-serif italic text-sm md:text-base text-center" data-id="element-307">
                "{IMAGES[index].caption}"
              </p>
            </div>
          </motion.div>
        </AnimatePresence>

        <button type="button" aria-label="Anterior" onClick={() => setIndex(prev => (prev - 1 + IMAGES.length) % IMAGES.length)} className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 w-8 h-8 md:w-9 md:h-9 rounded-full bg-white/85 hover:bg-white text-brand-choco-deep flex items-center justify-center shadow-md transition-colors z-10" data-id="element-308">
          ‹
        </button>
        <button type="button" aria-label="Siguiente" onClick={() => setIndex(prev => (prev + 1) % IMAGES.length)} className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 w-8 h-8 md:w-9 md:h-9 rounded-full bg-white/85 hover:bg-white text-brand-choco-deep flex items-center justify-center shadow-md transition-colors z-10" data-id="element-309">
          ›
        </button>
      </div>

      <div className="flex justify-center gap-2 mt-4" data-id="element-310">
        {IMAGES.map((_, i) => <button key={i} type="button" aria-label={`Ir a imagen ${i + 1}`} onClick={() => setIndex(i)} className={`h-2 rounded-full transition-all ${i === index ? 'w-7 bg-brand-gold' : 'w-2 bg-brand-choco/30 hover:bg-brand-choco/50'}`} data-id="element-311" />)}
      </div>
    </div>;
}